import type {Editor} from "slate";

/**
 * This is a Slate plugin that adds support for hr elements (horizontal rules).
 */
export const withHorizontalRules = (editor: Editor): Editor => {
    const {isBlock, isVoid} = editor;

    editor.isVoid = (element) =>
        element.type === "horizontal-rule" || isVoid(element);

    editor.isBlock = (element) =>
        element.type === "horizontal-rule" || isBlock(element);

    return editor;
};
